import { render, staticRenderFns } from "./TableMatches.vue?vue&type=template&id=5e4a026c&scoped=true&"
import script from "./TableMatches.vue?vue&type=script&lang=js&"
export * from "./TableMatches.vue?vue&type=script&lang=js&"
import style0 from "./TableMatches.vue?vue&type=style&index=0&id=5e4a026c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4a026c",
  null
  
)

export default component.exports